export default __webpack_public_path__ + "static/media/045-warrior.1b6ad23e.svg";